//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
    data: function () {
        return {
            servers: false,
            userToken:this.$until.getUrlParam('openId') || localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid"),
        }
    },
    props: {
        //导航栏的标题
        headerTitle: {
            type: String,
            default: "预约接送"
        },
        backUrl: {
            type: String,
            default: ""
        },
        rightContentProps: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        rightContentPropsMain: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        rightPhoneProps: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        serverphone: {
            type: String,
            default:localStorage.getItem('serverphone')||"400-610-5610"
        },
        backmethod: "",
    },
    watch: {},
    mounted(){
        this.$http.post(window.innerAPI + "?server=servicePhone", {
            userToken:this.userToken
        }).then(function (res) {
            if (res.data) {
                localStorage.setItem('serverphone',res.data.data.servicePhone)
            }
        }).catch(function (err) {

        })
        /*GetRequest().from && localStorage.setItem("appFrom", GetRequest().from);
         (GetRequest().openId || "" == GetRequest().openId) && (localStorage.removeItem("cdqcp_opid"),
         localStorage.setItem("cdqcp_opid", GetRequest().openId));*/
    },
    methods: {
        goback: function () {
            if (this.backmethod) {
                return this.backmethod();
            }
            if(this.backUrl){
                this.$router.push(this.backUrl)
            }else{
                window.history.go(-1);
            }
            /*if(window.location.hash.substr(0,window.location.hash.indexOf("?")) == "#/orderPickUp" || window.location.hash =="#/orderPickUp"){
             localStorage.setItem("cdqcp_shuttleend_selArea","");
             localStorage.setItem("cdqcp_shuttlestart_selArea","");
             localStorage.setItem("drvDate","");
             localStorage.setItem("personNum","");
             localStorage.setItem("currentPosition","");
             localStorage.setItem("cdqcp_conn","");
             localStorage.setItem("citys", "");
             "iOS" == localStorage.getItem("appFrom") || "Android" == localStorage.getItem("appFrom") ? location.href = "##backToVC=1" : location.href="/";
             }else  if(window.location.hash.substr(0,window.location.hash.indexOf("?")) =="#/order" || window.location.hash =="#/order"){
             "iOS" == localStorage.getItem("appFrom") || "Android" == localStorage.getItem("appFrom") ? location.href = "##backToVC=1" : location.href="/orders/allorders";
             }else{
             window.history.go(-1);
             }*/
        },
        onShortcutTouchStart(){
            if (event.cancelable) {
                if (!event.defaultPrevented) {
                    event.preventDefault();
                }
            }
        },
        more () {
            this.servers = !this.servers;
            setTimeout(()=>{
               this.servers = false
            },2000)
        },
        customer: function () {
            location.href = "tel:" + this.serverphone;
            this.servers = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/common/header/header.vue